import {lazy} from 'react';
import GenericFallbackSuspense from '../../ui/GenericFallback/GenericFallbackSuspense';

const PudoNewCollectionPoint = lazy(() => import('./PudoNewCollectionPoint'/* webpackChunkName: 'PudoNewCollectionPoint' */));

export default function PudoNewCollectionPointLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <PudoNewCollectionPoint />
    </GenericFallbackSuspense>
  );
}
